export default "__VITE_ASSET__CCbxDjrl__"